import { render, staticRenderFns } from "./transactionList.vue?vue&type=template&id=21280e68&"
import script from "./transactionList.vue?vue&type=script&lang=js&"
export * from "./transactionList.vue?vue&type=script&lang=js&"
import style0 from "./transactionList.vue?vue&type=style&index=0&id=21280e68&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports